var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopUpGreenTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 171,
    viewBox: "0 0 206 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.693 170.181C206.658 157.664 189.674 145.103 175.094 136.427C160.566 127.708 148.442 122.874 129.821 120.586C111.2 118.342 85.9797 118.687 75.3903 108.544C64.8008 98.4004 68.7911 77.7252 57.997 64.1287C47.203 50.5322 21.6247 44.0146 9.90984 31.7562C-1.85617 19.4546 0.241242 1.4555 2.33866 -16.5868H223.693V170.181Z",
    fill: "#60FF52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopUpGreenTab);
export default __webpack_public_path__ + "static/media/PopUpGreenTab.6629b6da25b67790a46f0596591a594e.svg";
export { ForwardRef as ReactComponent };